import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { MutationOptions } from '@/api/react-query'
import { SignupUserBody, SignupUserResponse } from '@/types'

export async function signupUser(body: SignupUserBody) {
  const response = await httpClient('user-manager').post<SignupUserResponse>(
    '/v1/signup',
    body,
    { ignoreErrorToast: true },
  )

  return response.data
}

export function useSignupUser(
  options?: MutationOptions<SignupUserResponse, SignupUserBody>,
) {
  return useMutation({
    mutationFn: signupUser,
    ...options,
  })
}
